import React from "react";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";

const TextInput = props => {

    return (
        <DatePicker className="input" selected={props.v} onChange={date => props.set(date)} />
    );
}

export default TextInput;